module.exports = __webpack_public_path__ + "img/20210828_214202.4d9e85c0.jpg";